import { queryOptions } from '@tanstack/react-query';
import { getReviewAutomationDashboard as getDashboardAPI } from 'src/common/Scraper';
import { ReviewAutomationDashboardResponse } from '../../types/review-automation.type';

/**
 * Returns React Query queryOptions to fetch review automation dashboard data for an account and location.
 *
 * @param accountId - Google Business Profile account ID
 * @param locationId - Google Business Profile location ID
 */
export const getReviewAutomationDashboardQuery = (accountId: string, locationId: string, siteId: string) => {
  return queryOptions({
    queryKey: ['getReviewAutomationDashboard', accountId, locationId, siteId],
    queryFn: () => getDashboardAPI(accountId, locationId, siteId),
    enabled: !!accountId && !!locationId,
  });
};

export default getReviewAutomationDashboardQuery;
